<template>
  <header :class="['header','panel', _isMobile()?'mobile':'']">
    <div class="logo-bar">
      <a-row type="flex" justify="space-between" class="menu-up">
        <a-col :xs="12" :sm="12" :md="12" :lg="12" :xl="12">
          <div class="logo">
            <router-link to="/"><img :src="logo?logo:'/img/logo.jpg'" alt="" /></router-link>
          </div>
        </a-col>
        <a-col :xs="12" :sm="12" :md="12" :lg="12" :xl="12">
          <div class="login-btn-wrap">
            <a-avatar v-if="userInfo && userInfo.id"
              @click="toCenter"
              icon="user"
              :src="avatarUrl"
            />
            <a-avatar v-else
              @click="toLogin"
              icon="user"
              :src="avatarUrl"
            />            
            <span v-if="userInfo && userInfo.id">
              <span @click="toCenter">{{userInfo.realname}}</span>
              <a-divider type="vertical"/>
              <span @click="handleLogout">退出</span>
            </span>
            <span v-else>
              <span @click="toLogin">登录</span>
              <a-divider type="vertical"/>
              <span @click="toRegister">注册</span>
            </span>
          </div>
        </a-col>
      </a-row>
    </div>
    <div
      :class="['menu-bar', showMenu ? 'show' : 'hide']"
      @mouseleave="leave"
      @mouseover="over"
    >
          <a-menu mode="horizontal" class="menu" :subMenuCloseDelay="1" overflowedIndicator="...">
            <a-menu-item>
              <router-link to="/"> {{menuText.length>0?menuText[0]:'首页'}} </router-link>
            </a-menu-item>
            <a-menu-item>
              <router-link to="/course"> {{menuText.length>1?menuText[1]:'教学课程'}} </router-link>
            </a-menu-item>
            <a-menu-item>
              <router-link to="/paper"> {{menuText.length>2?menuText[2]:'考级题库'}} </router-link>
            </a-menu-item>
            <a-menu-item>
              <router-link to="/contest"> {{menuText.length>3?menuText[3]:'赛事活动'}} </router-link>
            </a-menu-item>
            <a-menu-item>
              <router-link to="/production"> {{menuText.length>4?menuText[4]:'认证产品'}} </router-link>
            </a-menu-item>
            <a-menu-item>
              <router-link :to="{ path: '/news', query: { category: 1 } }">
                {{menuText.length>5?menuText[5]:'关于本站'}}
              </router-link>
            </a-menu-item>
            <template #overflowedIndicator>
              <span>xxx</span>
            </template>
          </a-menu>
    </div>
  </header>
</template>
<script>
import Vue from "vue";
import { TENANT_CONFIG,ACCESS_TOKEN } from "@/store/mutation-types";
import config from '../theme.config'
import { mapActions } from "vuex";
 import {mixinDevice} from '@/utils/mixin.js'
export default {
  name: "Header",
  mixins: [mixinDevice],
  props: {
    autoHide: {
      type: Boolean,
      default: false,
    },
  },
  components: {},
  data() {
    return {
      showLogin: false,
      showRegister: false,
      userInfo: {},
      showMenu: true,
      menuText: [],
      tenantInfo: {},
      logo: '',
      avatarUrl: '/img/avatar.png',
      token: ''
    };
  },
  created() {
    let that = this;
    this.userInfo = this.$store.state.user.info;
    console.log("用户信息：");
    console.log(this.userInfo);
    if (Vue.ls.get(ACCESS_TOKEN)){
      this.token = Vue.ls.get(ACCESS_TOKEN)
    }


    this.tenantInfo = Vue.ls.get(TENANT_CONFIG);
    this.logo = this.tenantInfo.logo
    
    if(this.tenantInfo.menuText){
      this.menuText = this.tenantInfo.menuText.split("，")
    }
    if(this.userInfo && this.userInfo.avatar){
      this.avatarUrl =  this.tenantInfo.qiniuDomain + "/" + this.userInfo.avatar
    }

    console.log(this._isMobile());
  },
  methods: {
    ...mapActions(["Logout"]),
    toLogin(){
      this.$router.push("/user/login")
    },
    toRegister(){
      this.$router.push("/user/register")
    },
    toCenter(){
      window.location.href = config.adminUrl + "/account/settings/base?token=" + this.token
    },
    leave() {
      if (this.autoHide) this.showMenu = false;
    },
    over() {
      if (this.autoHide) this.showMenu = true;
    },
    loginSuccess() {
      this.showLogin = false;
      this.userInfo = this.$store.state.user.info;
    },
    regSuccess() {
      this.showRegister = false;
      this.showLogin = true;
    },
    handleLogout() {
      const that = this;
      this.$confirm({
        title: "提示",
        content: "真的要注销登录吗 ?",
        onOk() {
          return that
            .Logout({})
            .then(() => {
              that.$router.push({ path: "/user/login" });
            })
            .catch((err) => {
              that.$message.error({
                title: "错误",
                description: err.message,
              });
            });
        },
        onCancel() {},
      });
    },
  },
};
</script>
<style lang="less" scoped>
.hide {
  height: 50px;
  background-color: transparent !important;
  transition: all 0.1s ease;
}

.logo-bar{
  background: #fff;
  .menu-up {
    max-width: 1200px;
    margin: auto;
    padding: 10px 0;
    height: 80px;
    .logo {
      margin-top: 5px;
      img {
        max-width: 100%;
        max-height: 50px;
      }
    }
    .login-btn-wrap {
      cursor: pointer;
      text-align: right;
      margin-top: 25px;
      // margin-right: 50px;
      .ant-avatar {
        margin-right: 5px;
      }
      span {
        color: black;
      }
    }
  }
}
.menu-bar {
  height: 35px;
  width: 100%;
  height: 40px;
  transition: all 0.1s ease;
  background-color: rgb(25, 95, 193);
  .menu {
    height: 40px;
    line-height: 40px;
    background: transparent;
    border-bottom: unset;
    max-width: 1200px;
    margin: auto;
    text-align: right;
    .ant-menu-submenu,
    .ant-menu-item > a {
      font-size: 18px;
      color: white;
    }
    .ant-menu-submenu-active,
    .ant-menu-item-active {
      background: rgba(0, 0, 0, 0.2);
      // border-radius: 15px;
      border-bottom: none !important;
    }
    /deep/.ant-menu-submenu-title{
      color: white!important;
    }
  }
  .ant-menu-horizontal{
    line-height: 35px;
  }
}

.mobile{
   .logo {
      margin-top: 5px;
      margin-left: 15px;
    }
    .login-btn-wrap {
      margin-right: 20px!important;
    }
     .ant-menu-item{
      padding: 0 8px;
    }
    .ant-menu-item > a {
      font-size: 12px!important;
    }
    .menu{
      padding: 0px 15px;
    }
}
</style>